import mustache from "mustache";
import { serviceProvider } from "../../../comun/provider/ServiceProvider";
import { fx_createFincaClimaHorarioGrpcService } from "../../../modulos/clima/services/FincaClimaHorarioGrpcService";
import { FincaClimaDataHorarioResponse } from "../../../modulos/clima/response/FincaClimaDataHorarioResponse";
import { parseRainspot, rainspotValueToColor } from "../../../utils/climaUtils";
import { ClimaSeccionBase } from "./ClimaSeccionBase";
import template from "./climaDistribucionPrecipitacionTemplate.html";

mustache.parse(template);

/** Grilla 7x7 (49 celdas) del campo `rainspot`. */
const CANTIDAD_CELDAS = 49;

/** Misma cadencia que `ClimaHorarioStatsRender` (dato de la hora vigente). */
const REFRESH_INTERVAL_MS = 60_000;

let DISTRIBUCION_ID = 0;

/** Sección "Distribución Precipitación en 20 Km." (Current): grilla 7x7
 *  coloreada por celda a partir de `rainspot` de la hora vigente. Se
 *  refresca solo cada minuto (ver `ClimaSeccionBase`). */
export class ClimaDistribucionPrecipitacionRender extends ClimaSeccionBase<FincaClimaDataHorarioResponse> {
  private readonly _id: number;

  constructor() {
    super(REFRESH_INTERVAL_MS);
    DISTRIBUCION_ID += 1;
    this._id = DISTRIBUCION_ID;
  }

  render(): string {
    const celdas = Array.from({ length: CANTIDAD_CELDAS }, (_, index) => ({
      index,
    }));
    return mustache.render(template, { id: this._id, celdas });
  }

  protected fetchList(): Promise<FincaClimaDataHorarioResponse[]> {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return fx_createFincaClimaHorarioGrpcService(finca.id).getListAsync();
  }

  protected onVigente(current: FincaClimaDataHorarioResponse): void {
    const valores = parseRainspot(current.rainspot);
    for (let i = 0; i < CANTIDAD_CELDAS && i < valores.length; i++) {
      const cell = document.getElementById(`clima-precip-cell-${this._id}-${i}`);
      if (cell) cell.style.backgroundColor = rainspotValueToColor(valores[i]);
    }
  }
}
